export const people = {
  peopleStatus: [{
    value: 0, label: '未知'
  }, {
    value: 1, label: '启用'
  }, {
    value: 2, label: '未激活'
  }, {
    value: 8, label: '禁用'
  }],
  lifeInsuranceAuthority: [{
    label: '销售人员入司审批',
    value: '01'
  },
  {
    label: '销售人员解约审批',
    value: '02'
  },
  {
    label: '销售人员解约恢复审批',
    value: '03'
  },
  {
    label: '招募批次审批',
    value: '04'
  },
  {
    label: '培训立项审批',
    value: '05'
  },
  {
    label: '培训班课程审批',
    value: '06'
  },
  {
    label: '公告审批',
    value: '07'
  },
  {
    label: '法律合同审批',
    value: '08'
  },
  {
    label: '招募人员基本信息审批',
    value: '09'
  },
  {
    label: '折标政策审批',
    value: '010'
  },
  {
    label: '首期政策审批',
    value: '011'
  },
  {
    label: '续期政策审批',
    value: '012'
  },
  {
    label: '直辖佣金政策审批',
    value: '013'
  },
  {
    label: '基本法额外奖励政策审批',
    value: '014'
  },
  {
    label: '机构费率政策审批',
    value: '015'
  }],
  macState: [
    {
      label: '禁用',
      value: 1
    },
    {
      label: '启用',
      value: 2
    }
  ]
}

export default {
  people
}



// WEBPACK FOOTER //
// ./src/data/people.js